import { AuthProvider } from "./contexts/AuthContext";
import { NavigationFeedbackProvider } from "./contexts/NavigationFeedbackContext";
import { UIProvider } from "./contexts/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

export const AppProviders = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <NavigationFeedbackProvider>
        <AuthProvider>
          <UIProvider>{children}</UIProvider>
        </AuthProvider>
      </NavigationFeedbackProvider>
    </QueryClientProvider>
  );
};
